<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="card p-4">
          <div class="media">
            <div class="avatar-sm mr-3">
              <span
                class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22"
              >
                <i class="bx bx-image bx-sm"></i>
              </span>
            </div>
            <div class="media-body">
              <div class="row">
                <div class="col-sm-9">
                  <h5 class="mt-3">{{ $t("nlp.image-to-text") }}</h5>
                </div>
                <div class="col-sm-3 text-right">-</div>
              </div>
            </div>
          </div>
          <div class="row mt-5 mb-4">
            <div class="col-6 mb-2">
              <div class="form-group">
                <b-form-file
                  :state="true"
                  :placeholder="$t('overview.table.all.choose')"
                  :drop-placeholder="$t('overview.table.all.drop')"
                  @change="ImageUpload"
                  accept="image/*"
                >
                </b-form-file>
              </div>
            </div>
            <div class="col-sm-6 mr-2">
              <div
                class="btn btn-success btn-block py-2 mr-2"
                @click="SearchResult"
              >
                <b-spinner
                  v-if="loading_search"
                  label="Loading ..."
                  small
                ></b-spinner>
                <span v-if="!loading_search"> Submit </span>
                <span v-if="loading_search"> Loading.. </span>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="row mt-5">
              <div class="col-5">
                <div class="border card h-100 p-2">
                  <h5 class="mt-2 mb-3">{{ $t("nlp.image-preview") }}</h5>
                  <img
                    :src="
                      previewUrl
                        ? previewUrl
                        : 'https://cdn-icons-png.flaticon.com/512/685/685669.png?w=826&t=st=1687578223~exp=1687578823~hmac=6664f782343549f9c4ac332b815d5e4a79ca5128df3aa0f6ba6870b4c797abe4'
                    "
                    class="avatar-xl rounded mr-4 text-center w-100 h-100"
                    :class="previewUrl ? 'p-1' : 'p-5'"
                  />
                </div>
              </div>
              <div class="col-7">
                <div class="border card h-100 p-2">
                  <h5 class="mt-2 mb-2">{{ $t("nlp.results") }}</h5>
                  <p v-html="result_text"></p>
                  <span class="text-primary" v-if="error_message && error">
                    {{ error_message }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import Swal from "sweetalert2";
import PreferenceService from "@/helpers/preference.service.js";
import axios from "axios";

export default {
  page: {
    title: "Tools Website",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      img_to_text: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      result_text: "-",
      error_message: "",
      previewUrl: null,
      image_avatar: "",
      loading_search: "",
      error: "",
      search: false,
      searchKey: "",
      total_results: "",
      dnf: false,
      dnfp: false,
      is_spam: "",
      search: false,
      title: "OCR",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "OCR",
          active: true,
        },
      ],
    };
  },
  methods: {
    getPreferences() {
      let id = 95;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          this.img_to_text.api_host = response.data.data.api_host;
          this.img_to_text.x_rapidapi_host = response.data.data.api_header_host;
          this.img_to_text.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    ImageUpload(evt) {
      // console.log("img to text");
      this.previewUrl = URL.createObjectURL(evt.target.files[0]);
      this.image_avatar = evt.target.files[0];
      this.error = false;
      this.error_message = "";
      this.result_text = "-";
    },

    SearchResult() {
      this.error = "";
      this.loading_search = true;
      this.search = true;

      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.img_to_text.x_rapidapi_host,
        "x-rapidapi-key": this.img_to_text.x_rapidapi_key,
      };

      // console.log("headers", headers);
      const formImages = new FormData();
      formImages.append("image", this.image_avatar, this.image_avatar.name);
      // console.log("fi", formImages);
      return axios
        .post(this.img_to_text.api_host, formImages, { headers: headers })
        .then((response) => {
          const rapid_data = response.data;
          // console.log("rdd", rapid_data);
          this.result_text = rapid_data.text;
          this.loading_search = false;
        })
        .catch((err) => {
          // console.log("img err ->", err.response.data.message);
          this.error = true;
          this.error_message = err.response.data.message;
          this.result_text = "";
          this.loading_search = false;
        });
    },
  },
  mounted() {
    this.getPreferences();
  },
};
</script>

<style scoped>
.image {
  height: 250px;
}
.loading {
  padding-top: 20%;
  padding-bottom: 20%;
}
</style>
